module.exports = __webpack_public_path__ + "static/media/Document3.02b23c97.png";